import { render } from "./ProductTraceCard.vue?vue&type=template&id=5f6c356f&scoped=true"
import script from "./ProductTraceCard.vue?vue&type=script&lang=js"
export * from "./ProductTraceCard.vue?vue&type=script&lang=js"

import "./ProductTraceCard.vue?vue&type=style&index=0&id=5f6c356f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dxworks\\Downloads\\dpp_adm_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f6c356f"]])

export default __exports__